/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';
import { IToysrusImageData } from './toysrus-image.data';
import { IToysrusImageProps } from './toysrus-image.props.autogenerated';

export interface IToysrusImageViewProps extends IToysrusImageProps<{}>  {
    toysrusImage?: React.ReactNode;
}

/**
 *
 * ToysrusImage component
 * @extends {React.PureComponent<IToysrusImageProps<IToysrusImageData>>}
 */
class ToysrusImage extends React.PureComponent<IToysrusImageProps<IToysrusImageData>> {
    public render(): JSX.Element | null {
        const {cssClassName,toysrusImage} = this.props.config;
        const imageProps = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: toysrusImage && toysrusImage.imageSettings,
          };
        const toysrusDynamicImage = toysrusImage && (
            <Msdyn365.Image className={cssClassName} {...toysrusImage} {...imageProps} editProps ={{key:this.props.config.toysrusImage || {}, requestContext: this.props.context.request}}/>
          );
        const ToysrusImageViewProps = {
            ...this.props,
            toysrusImage: toysrusDynamicImage,
        };
        return this.props.renderView(ToysrusImageViewProps);
    }
}

export default ToysrusImage;
